"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
/**
 * Функция конвертирует meta-информацию лога в key-value массив.
 * Допускается один уровень вложенности.
 *
 * @export
 * @param {TMeta} meta - мета информация
 * @returns {TKeyValue[]}
 */
function convertMetaToKeyValue(meta) {
    var keysOfMeta = ramda_1.keys(meta);
    var warnings = [];
    var result = keysOfMeta.reduce(function (acc, keyOfMeta) {
        var value = meta[keyOfMeta];
        if (ramda_1.type(value) === 'Object') {
            var _a = convertMetaJsonToKeyValue(value, keyOfMeta), result_1 = _a.result, warningsOfJson = _a.warnings;
            warnings.push.apply(warnings, warningsOfJson);
            return acc.concat(result_1);
        }
        if (isValidValue(value)) {
            return acc.concat({ key: keyOfMeta, value: value });
        }
        warnings.push(
        // tslint:disable-next-line:prefer-template
        'Logger warning! The value of meta must be valid type.\n'
            + ("Key: " + keyOfMeta + ", value type: " + ramda_1.type(value) + "\n")
            + 'The field will be omitted.');
        return acc;
    }, []);
    if (warnings.length) {
        console.warn.apply(console, warnings);
    }
    return result;
}
exports.convertMetaToKeyValue = convertMetaToKeyValue;
function convertMetaJsonToKeyValue(json, prefix) {
    var keysOfJson = ramda_1.keys(json);
    var warnings = [];
    var result = keysOfJson.reduce(function (acc, keyOfJson) {
        var value = json[keyOfJson];
        var key = prefix + "." + keyOfJson;
        if (isValidValue(value)) {
            return acc.concat({ key: key, value: value });
        }
        warnings.push(
        // tslint:disable-next-line:prefer-template
        'Logger warning! The value of nested object must be primitive or array of primitves\n'
            + ("Key: " + key + ", value type: " + ramda_1.type(value) + "\n")
            + 'The field will be omitted.');
        return acc;
    }, []);
    return { result: result, warnings: warnings };
}
// tslint:disable-next-line:no-any
function isValidValue(value) {
    return Array.isArray(value)
        ? validateArrayOfPrimitives(value)
        : validatePrimitives(value);
}
// tslint:disable-next-line:no-any
function validateArrayOfPrimitives(arr) {
    return ramda_1.all(validatePrimitives, arr);
}
// tslint:disable-next-line:no-any
function validatePrimitives(value) {
    var validTypes = ['Number', 'Boolean', 'String', 'Null', 'Undefined'];
    return ramda_1.any(ramda_1.equals(ramda_1.type(value)), validTypes);
}
//# sourceMappingURL=convertLogMeta.js.map